<template>
	<div>
		<sBox title="Grade de Tipo de Propostas">
			<div slot="tools">
				<aBtn
					action="private-save-types_of_proposals"
					@click="$refs.modal.open()"
					text="Categoria"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>
			<div slot="body">
				<br />
				<div class="row">
					<div class="pull-right col-sm-4">
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-search"></i>
							</span>
							<input
								type="text"
								@input="filter($event.target.value)"
								placeholder="Pesquisar"
								class="form-control"
							/>
						</div>
					</div>
				</div>
				<br />
				<sTable
					ref="tab"
					actionRead="private-read-types_of_proposals"
					actionDelete="private-delete-types_of_proposals"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					:tags="tags"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppTiposDePropostas',
		components: { sTable, sBox, modal, aBtn },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'titulo', label: 'Tipos de Proposta' },
					{ data: 'calculo', label: 'Cálculo' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
				],
				tags: [
					{
						cod: 'calculo',
						value: 'mes',
						html: 'MENSAL',
						color: 'warning',
					},
					{
						cod: 'calculo',
						value: 'ano',
						html: 'ANUAL',
						color: 'default',
					},
					{
						cod: 'calculo',
						value: 'vida',
						html: 'VIDA',
						color: 'primary',
					},
				],
			};
		},

		methods: {
			filter(data) {
				if (data != '') {
					this.$refs.tab.setFilter(`
							cod like '%${data}%' or 
							titulo like '%${data}%' or 
							calculo like '%${data}%'
					`);
				} else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Tipos de Propostas', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/types-of-proposals/index.vue